import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import BasicRadioButton from '../../../../shared/components/BasicRadioButton';
import Textarea from '../../../../shared/components/Textarea';
import { safeFind } from '../../../../shared/misc/utils';
import { Button } from '../../../../shared/components';
import Context from '../../../App/MainProvider/context';
import { canChooseIndication } from './flowFeedbackRules';

interface Props {
  title: string;
  options: { id: number; name: string }[];
  canStepForward: boolean;
  feedbackToSpe: boolean;
  isFinalReview: boolean;
  state: { indicationCode: string; comment: string };
  onChange: (state: { indicationCode: string; comment: string }) => void;
  saveFeedback: (comment: string) => void;
  speCanFeedback: boolean;
  currentStep: number;
  isStepRevise: boolean;
  children?: React.ReactNode;
}

const FlowFeedbackProvider: React.FC<Props> = (props) => {
  const {
    title,
    options,
    canStepForward,
    feedbackToSpe,
    isFinalReview,
    state,
    onChange,
    saveFeedback,
    speCanFeedback,
    children,
    currentStep,
    isStepRevise,
  } = props;
  const { t } = useTranslation();

  const { inSuperUserMode } = useContext(Context);

  const renderOptions = (rOptions: { id: number; name: string }[]) =>
    rOptions.map((option) => {
      let lblText = '';
      if (option.name === 'FEEDBACK') {
        const toSpe = feedbackToSpe ? t('toSpecialist') : '';
        lblText = t(`flowIndications.${option.name}`, { toSpe });
      } else if (option.name === 'APPROVE') {
        lblText = t('approve');
      } else {
        lblText = isFinalReview ? t('approve') : t('flowIndications.SEND');
      }

      return (
        <div key={option.name} className="basic-radio-btn py-1">
          <BasicRadioButton
            id={`feedbackType_${option.name}`}
            name="feedbackType"
            label={lblText}
            radioValue={option.id}
            active={state.indicationCode === option.name}
            onChange={(value) =>
              onChange({ ...state, indicationCode: safeFind(options, (x) => x.id === value).name })
            }
          />
        </div>
      );
    });

  return (
    <div className="flow-feedback-content">
      <p className="flow-feedback-title">{title}</p>
      {canChooseIndication({
        canStepForward,
        speCanFeedback,
        inSuperUserMode: inSuperUserMode(),
        currentStep,
        isStepRevise,
      }) && (
        <>
          {renderOptions(options)}
          <hr />
        </>
      )}
      <div className="flow-feedback-content__comment">
        <Textarea
          name="comment"
          placeholder={speCanFeedback ? 'Type a Comment' : 'Type your Feedback'}
          maxLength={500}
          onChange={(e) => onChange({ ...state, comment: e.target.value })}
          value={state.comment}
        />
        <div className="d-flex justify-content-between">
          <Button
            htmlId="btnWord"
            className="btn-secondary py-1"
            onClick={() => saveFeedback(state.comment)}
            text={speCanFeedback ? t('saveCommentBeforeSend') : t('saveFeedbackBeforeApply')}
          />
          {children}
        </div>
      </div>
    </div>
  );
};

export default FlowFeedbackProvider;
